import React from 'react';
import './ProgressBarButton.css'
import './Common.css'

export type ProgressBarButtonProps = {
    text: string,
    progress: number,
    onSuccessClick: (_: any) => void,
    onFailClick: (_: any) => void,
    backgroundColor: string
    textColor: string
}

export function ProgressBarButton({props}: { props: ProgressBarButtonProps }) {
    const fillBarStyle = {
        background: "#5e5e5e",
        width: `${props.progress * 100}%`,
        height: "100%",
    }

    const textStyle = {
        color: props.textColor,
    };

    if (props.progress >= 1) {
        fillBarStyle.width = `${100}%`
        fillBarStyle.background = props.backgroundColor
    }

    const onClick = (event: any) => {
        if (props.progress >= 1) props.onSuccessClick(event);
        else props.onFailClick(event);
    }

    return (
        <div className="button-outer">
            <button className="empty-button wa-button" onClick={onClick}>
                <div className="progress-bar-button-background progress-bar-button-inner">
                    <div style={fillBarStyle}/>
                </div>
                <div className="progress-bar-button-inner flex-center">
                    <span className="progress-bar-button-content " style={textStyle}>{props.text}</span>
                </div>
            </button>
        </div>
    )
}